module.exports = __webpack_public_path__ + "static/port-map-bd9c3d82ff570ec806ce84eb266c951f.jpg";